// Slick Carousel
import Glide from "@glidejs/glide";

class CarouselHeroCaption {
  constructor() {
    const carousels = document.querySelectorAll(".carousel-hero-caption");

    if (!carousels.length) {
      return;
    }

    carousels.forEach((carousel) => {
      this.initCarousel(carousel);
    });
  }

  initCarousel(carousel) {
    // Safe to touch styles now
    carousel.style.backgroundColor = "#000"; // Set background color of carousel to black

    const carouselTrack = carousel.querySelector(
      ".wp-block-group"
    );

    // If the expected inner structure is missing, bail early
    if (!carouselTrack) {
      return;
    }

    const carouselSlides = carouselTrack.querySelector(
      ":scope > .wp-block-group"
    );

    if (!carouselSlides) {
      return;
    }

    const carouselIndividualSlide = carouselSlides.querySelectorAll(
      ".wp-block-cover"
    );

    if (!carouselIndividualSlide.length) {
      return;
    }

    const slideIntervalSeconds = Number.parseInt(
      carousel.dataset.slideInterval,
      10
    );
    const autoplay =
      Number.isFinite(slideIntervalSeconds) && slideIntervalSeconds > 0
        ? slideIntervalSeconds * 1000
        : 6000;

    // Add Glide classes
    carouselTrack.classList.add("glide__track");
    carouselTrack.dataset.glideEl = "track";
    carouselSlides.classList.add("glide__slides");
    carouselIndividualSlide.forEach((item) => {
      item.classList.add("glide__slide");
      item.style.transition = "opacity 1s"; // Add transition style
    });

    // Tweak styles
    carousel.style.overflow = "hidden";
    carouselSlides.style.flexWrap = "nowrap";

    var fullWidthGlide = new Glide(carousel, {
      type: "carousel",
      perView: 1,
      autoplay,
      peek: 0,
      gap: 0,
      animationDuration: 10,
      swipeThreshold: 10,
    }).mount();

    // Adjust opacity of slides
    fullWidthGlide.on("move", function () {
      carouselIndividualSlide.forEach((item) => {
        item.style.opacity = 0.1;
      });
    });

    fullWidthGlide.on("move.after", function () {
      const current = carouselIndividualSlide[fullWidthGlide.index];
      if (current) current.style.opacity = 1;
    });
  }
}

export default CarouselHeroCaption;
